export default __webpack_public_path__ + "static/media/fa0a865b60b874f0c9e6de75664facd4.jpg";